var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Cập nhật gửi tin",
        visible: _vm.dialogVisible,
        width: "700px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "updateData",
          attrs: {
            "label-width": "120px",
            model: _vm.updateData,
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Tiêu đề", prop: "title" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập tiêu đề gửi tin" },
                model: {
                  value: _vm.updateData.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.updateData, "title", $$v)
                  },
                  expression: "updateData.title",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Nội dung", prop: "content" } },
            [
              _c("el-input", {
                attrs: {
                  rows: 2,
                  type: "textarea",
                  autosize: "",
                  placeholder: "Nhập nội dung gửi tin",
                },
                model: {
                  value: _vm.updateData.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.updateData, "content", $$v)
                  },
                  expression: "updateData.content",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Trạng thái" } },
            [
              _c("el-switch", {
                model: {
                  value: _vm.updateData.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.updateData, "status", $$v)
                  },
                  expression: "updateData.status",
                },
              }),
            ],
            1
          ),
          _vm.updateData.typeReceive == "plus" &&
          (_vm.updateData.type == "fees" || _vm.updateData.type == "salary")
            ? _c(
                "el-form-item",
                { attrs: { label: "Tháng", prop: "month" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.updateData.month,
                        callback: function ($$v) {
                          _vm.$set(_vm.updateData, "month", $$v)
                        },
                        expression: "updateData.month",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: -1 } }, [
                        _vm._v("Tháng trước"),
                      ]),
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("Tháng hiện tại"),
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("Tháng sau"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "Ghi chú", prop: "note" } },
            [
              _c("el-input", {
                attrs: {
                  rows: 2,
                  placeholder: "Nhập nội dung ghi chú",
                  type: "textarea",
                },
                model: {
                  value: _vm.updateData.note,
                  callback: function ($$v) {
                    _vm.$set(_vm.updateData, "note", $$v)
                  },
                  expression: "updateData.note",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("updateData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm("updateData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }